module.exports = __webpack_public_path__ + "img/numberEle.5bf6acba.svg";